/**
 * Склонение «балл» по ТЗ:
 * 0.0, 5.0 → баллов
 * 0.1–4.9 → балла
 */
export const formatRatingScoreUnit = (rating: number): string => {
  const normalized = Math.round(Math.abs(rating) * 10) / 10;

  if (normalized === 0 || normalized === 5) {
    return 'баллов';
  }

  return 'балла';
};

export const formatRatingValue = (rating: number): string => {
  return rating.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
};
